import stages from '../../constants/stages';
import { SubmitTraitsGenerationContract } from '../stage-contracts';

const handleMergeResult = (currentFlowData, result) => {
  if (!result) return currentFlowData;

  if (!SubmitTraitsGenerationContract.isValid(result)) {
    // eslint-disable-next-line no-console
    console.warn(
      `${String(
        stages.SUBMIT_TRAITS_GENERATION
      )} stage: handler returned invalid contract, skipping`
    );
    return currentFlowData;
  }

  const traits = SubmitTraitsGenerationContract.get(result);

  if (!traits) return currentFlowData;

  const merged = { ...currentFlowData };
  const currentTraits = merged.traits || {};

  merged.traits = {
    ...currentTraits,
    ...traits,
  };

  return merged;
};

const runSubmitTraitsGenerationStage = ({ state, form, flowData, onRun }) =>
  onRun({
    stage: stages.SUBMIT_TRAITS_GENERATION,
    initialContext: {
      getDefaultFieldsValues: form.getDefaultValues,
      getFieldsValues: form.getValues,
      state: state.data,
      initialState: state.getInitialState(),
      stateDiff: state.getStateDiff(),
    },
    flowData,
    onMergeResult: handleMergeResult,
    getAdditionalContext: ({ chunkId }) => ({
      modifiedAttributes: state.getModifiedAttributes(chunkId),
      lastModifiedAttributes: state.getLastModifiedAttributes(chunkId),
    }),
  });

export default runSubmitTraitsGenerationStage;
